


































































































import Vue from "vue";
import Component from "vue-class-component";
import { formatImageUrl } from "@/common/utils";
import { TimeLineService } from "@/common/api";
import qNotify from "@/common/qNotify";

@Component({
  name: "GroupPhotoIndex",
})
export default class GroupPhotoIndex extends Vue {
  currentAlbum = null;
  currentAlbumKey = null;
  currentImage = null;
  currentImageKey = null;

  isShowPopup = false;

  state = null;

  list = [];
  params: any = {
    groupId: null,
    page: 1,
    direction: "desc",
    sort: "post_date",
    status: ["release"],
  };

  get hasNext() {
    return !(
      this.currentAlbumKey === this.list.length - 1 &&
      this.currentImageKey === this.currentAlbum.images.length - 1
    );
  }

  mounted() {
    this.params.groupId = Number.parseInt(
      this.$router.currentRoute.params.groupId
    );
  }

  async getList($state) {
    try {
      this.state = $state;
      // const result = await appGroupApi.userGroupAlbums(this.params);
      const result = await TimeLineService.memberGroupInfoTimeline(this.params);
      if (result.data.articles.length > 0) {
        this.params.page += 1;
        this.list.push.apply(this.list, result.data.articles);
        $state.loaded();
      } else {
        $state.complete();
      }
    } catch (error) {
      $state.complete();
      if (error.status === 404) {
        return this.$router.push({
          name: "group.notFound",
          params: { groupId: this.params.id },
        });
      } else {
        qNotify.error({
          text: error.body.message,
        });
      }
    }
  }

  imagesList(images: []) {
    return images.slice(0, 3);
  }

  getImagePath(image, size = "400x400") {
    return image
      ? formatImageUrl(image.name, size)
      : formatImageUrl("notfound.jpg", size);
  }

  showImage(album, albumKey, image, imageKey) {
    this.currentAlbum = album;
    this.currentAlbumKey = albumKey;
    this.currentImage = image;
    this.currentImageKey = imageKey;
    this.isShowPopup = true;
  }

  next(step) {
    // this.currentAlbum = album;
    if (this.currentImageKey + step === -1) {
      this.currentAlbumKey -= 1;
      this.currentImageKey = this.list[this.currentAlbumKey].images.length - 1;
      // prev album
    } else if (
      this.currentImageKey + step ===
      this.currentAlbum.images.length
    ) {
      this.currentAlbumKey += 1;
      this.currentImageKey = 0;
      // next album
    } else {
      this.currentImageKey = this.currentImageKey + step;
    }
    this.currentAlbum = this.list[this.currentAlbumKey];
    this.currentImage = this.currentAlbum.images[this.currentImageKey];
    // auto fetch next album
    if (this.currentAlbumKey == this.list.length - 2) {
      this.getList(this.state);
    }
  }
}
